import { supabase } from '@/services/supabaseClient';
export async function loadClinicalNoteAuthorities(appointmentIds) {
 if(!appointmentIds?.length)return [];
 const {data,error}=await supabase.rpc('afrimed_get_clinical_note_authority',{p_appointments:appointmentIds});
 if(error)throw error;return data||[];
}
export async function loadClinicalNoteAuthority(appointmentId){return (await loadClinicalNoteAuthorities([appointmentId]))[0]||{appointment_id:appointmentId,final_report:null,draft_report:null};}
export async function persistClinicalNote({appointmentId,content,finalise=false,expectedFinal=null,amendmentReason=null}){
 const {data,error}=await supabase.rpc('afrimed_save_clinical_note',{p_appointment:appointmentId,p_content:content,p_finalise:finalise,p_expected_final:expectedFinal,p_amendment_reason:amendmentReason});
 if(error)throw error;return data;
}
